import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fas);

const IconSociogram = ({ icon }) => {
  return (
    <div>
      <FontAwesomeIcon className="iconSociogram-icon" icon={['fas', icon]} />
    </div>
  );
};

export default IconSociogram;
